import { render, staticRenderFns } from "./objectInfo.vue?vue&type=template&id=a16a7c2e&scoped=true"
import script from "./objectInfo.vue?vue&type=script&lang=js"
export * from "./objectInfo.vue?vue&type=script&lang=js"
import style0 from "./objectInfo.vue?vue&type=style&index=0&id=a16a7c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16a7c2e",
  null
  
)

export default component.exports